<section class="px-0 pt-0 pb-0 slider">
  <owl-carousel-o [options]="customOptions">
    <ng-template carouselSlide *ngFor="let slider of bannersliders"
      ><img [src]="slider.image"
    /></ng-template>
  </owl-carousel-o>
</section>
<section class="fabpik-list mt-20">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 feature-list">
        <h3 class="sec_title">What is Fabpik</h3>
        <p class="mt-10">
          Fabpik is a multi-vendor Ecommerce platform hosting a wide range of
          products for babies to early teen kids from Sellers across India.
        </p>
        <p>
          Fabpik Seller world is the interface for Sellers which helps to
          Register and sell products online
        </p>
      </div>
      <div class="col-lg-6">
        <ngx-slick-carousel
          class="carousel"
          #slickModal="slick-carousel"
          [config]="slideConfig"
        >
          <div
            ngxSlickItem
            *ngFor="let testimonial of testimonials"
            class="slide"
          >
            <div class="testimonial-item">
              <div class="testimonial-item-inner">
                <div class="quote-icon">
                  <img src="assets/images/quote2.png" alt="Icon" />
                </div>
                <!-- /.quote-icon -->
                <div class="client-testimonial">
                  <div class="testimonial-details">
                    <div class="details">
                      <p>{{ testimonial.content }}</p>
                    </div>
                    <!-- /.details -->
                    <div class="client-area">
                      <h4 class="client-name">{{ testimonial.name }}</h4>
                      <!--  /.client-name -->
                    </div>
                    <!-- /.client-area -->
                  </div>
                  <!-- /.testimonial-details -->
                </div>
                <!-- /.client-testimonial -->
              </div>
              <!-- /.testimonial-item-inner -->
            </div>
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
  </div>
</section>
<section class="fabpik-registration">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 offset-lg-3 text-center m-t30">
        <h3 class="sec_title text-center">Why Sell Online</h3>
        <p>Sell your products to Millions of Customers across India.</p>
      </div>
      <div class="col-lg-12 row">
        <div class="col-lg-4">
          <div class="col-lg-12">
            <div class="div-registrar">
              <div class="img-reg bg-1">
                <img src="assets/images/icons/growth_in_business.png" />
              </div>
              <p class="">
                <label>Growth in online business</label>
                The Indian Ecommerce market is expected to grow to US$200
                billion by 2026. Thus, Increasingly Retailers are moving Online
                for its many benefits. !
              </p>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="div-registrar">
              <div class="img-reg bg-2">
                <img src="assets/images/icons/orders_from_across _india.png" />
              </div>
              <p class="">
                <label>Get orders Across India </label> Reach more than
                80millions+ people in India alone at one go without any
                restrictions leading to increased Sales.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <img src="assets/images/sellerscreen.png" />
        </div>
        <div class="col-lg-4">
          <div class="col-lg-12">
            <div class="img-reg bg-2">
              <img src="assets/images/icons/low_costs_in_doing_busines.png" />
            </div>
            <div class="div-registrar">
              <p class="">
                <label> Low costs of doing business</label> No more spending on
                store setup and other infrastructure costs. Register and sell at
                a distance of a click.
              </p>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="div-registrar">
              <div class="img-reg bg-1">
                <img src="assets/images/icons/earn-more.png" />
              </div>
              <p class="">
                <label>Earn more</label> Get your payments settled in as little
                as 7 days of sales with our fastest settlement processes in
                place which are at par with industry standards.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="fabpik-why">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 offset-lg-3 m-t30">
        <h3 class="sec_title text-center">Why sell with Fabpik</h3>
        <p>
          Sell your products to an increased number of new and experienced busy
          parents constantly wanting the best for their kids with just a click
          away.
        </p>
      </div>
      <div class="col-lg-12 row">
        <div class="col-lg-3">
          <div class="div-features">
            <div class="img-div bg-1">
              <img src="assets/images/icons/reach.png" />
            </div>
            <p>
              <label>Reach</label>Widen your reach to 80million + people using
              e-commerce for shopping and grow your business with help of our
              dedicated Seller mangement team.
            </p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="div-features">
            <div class="img-div bg-2">
              <img src="assets/images/icons/ease.png" />
            </div>
            <p>
              <label>Ease</label>Start selling with just a few clicks to get
              Registered. From then on sit back and see your business grow.
            </p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="div-features">
            <div class="img-div bg-3">
              <img src="assets/images/icons/trust.png" />
            </div>
            <p>
              <label>Trust & Transparency</label>We believe in providing maximum
              support and trust to all our sellers. Access all your sales and
              other information readily available at dedicated Seller portals.
            </p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="div-features">
            <div class="img-div">
              <img src="assets/images/icons/securepayments.png" />
            </div>
            <p>
              <label>Secure and Prompt payments </label>Check all your Revenue
              at your dedicated seller dashboards and get your payments paid
              securely in as little as 7 days of sales.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="sell-fabpik" #orderSummary>
  <div class="container">
    <div class="row v-row">
      <div class="col-lg-12 text-center m-t30">
        <h3 class="sec_title text-center">How To Sell On Fabpik?</h3>
      </div>
      <div class="col-lg-6 left-img">
        <div>
          <img src="assets/images/line_01.png" class="line" />
        </div>
        <img src="assets/images/slider/3.png" class="img-block" />
      </div>
      <div class="col-lg-6">
        <div class="icon"><img src="assets/images/icons/register.png" /></div>
        <h4>Register Seller Accounts:</h4>
        <p>
          Active Bank Account, GST number, PAN is all what you need to
          <a
            href="https://portal.fabpik.in/seller/register"
            target="_blank"
            >register</a
          >
          your Seller account. Get access to (Fabpik Seller World) Seller
          Dashboard from where you can manage all your business online.
        </p>
      </div>
    </div>
    <div class="row v-row mobile-flex">
      <div class="col-lg-6">
        <div class="icon"><img src="assets/images/icons/upload.png" /></div>
        <h4>Upload Products:</h4>
        <p>
          Upload your products at one click. Do this by using our Product Upload
          tool or avail help from our Seller support team.
          <a
            href="https://portal.fabpik.in/seller/register"
            target="_blank"
            >help</a
          >
        </p>
      </div>
      <div class="col-lg-6 left-img">
        <div>
          <img src="assets/images/line_02.png" class="line2" />
        </div>
        <img src="assets/images/slider/2.png" class="img-block" />
      </div>
    </div>
    <div class="row v-row">
      <div class="col-lg-6 left-img">
        <div>
          <img src="assets/images/line_01.png" class="line" />
        </div>
        <img src="assets/images/slider/1.png" class="img-block" />
      </div>
      <div class="col-lg-6">
        <div class="icon"><img src="assets/images/icons/deliver.png" /></div>
        <h4>Deliver products:</h4>
        <p>
          Get an order, get notified instantly and deliver products on time.
        </p>
      </div>
    </div>
    <div class="row v-row mobile-flex">
      <div class="col-lg-6">
        <div class="icon"><img src="assets/images/icons/paid.png" /></div>
        <h4>Get Paid:</h4>
        <p>
          Get an order, get notified instantly and deliver products on time.
        </p>
      </div>
      <div class="col-lg-6 left-img">
        <div>
          <img src="assets/images/line_02.png" class="line4 none" />
        </div>
        <img src="assets/images/slider/4.png" class="img-block" />
      </div>
    </div>
  </div>
</section>

<section class="category-section">
  <div class="container">
    <div class="row mx-auto">
      <h3 class="sec_title text-center col-lg-12">Categories</h3>

      <div class="cat-block beffect" *ngFor="let homestaticdata of homedata">
        <a (click)="getProductCategory(homestaticdata.Link)">
          <img [src]="homestaticdata.image" />
          <h4>{{homestaticdata.name}}</h4>
        </a>
      </div>
    </div>
  </div>
</section>

<section class="brands-section">
  <div class="container">
    <h3 class="sec_title text-center col-lg-12">Our Brands</h3>

    <div class="">
     <owl-carousel-o [options]="RecommendOptions">
      <ng-template carouselSlide *ngFor="let brand of brands">
        <a href="https://fabpik.in/products?brands=%5B{{brand.redirectid}}%5D" target="_bank"
          ><img [src]="brand.image"
        /></a>
      </ng-template>
    </owl-carousel-o>
    </div>
  </div>
</section>
<section class="video-section">
  <div class="container">
    <div class="">
      <div class="col-lg-6 offset-lg-3 m-t30">
        <h3 class="sec_title text-center">Our Videos</h3>
      </div>
      <owl-carousel-o [options]="customOptions">
        <ng-template carouselSlide *ngFor="let slider of sliders">
          <h4>{{ slider.title }}</h4>
          <div class="video_img">
            <img
              [src]="slider.image"
              alt="video_img"
              class="video_bg_img img-fluid"
            />
            <a
              class="popup-youtube video_icon"
              (click)="
                openVerticallyVideoCentered(content2);
                setModalVideo(slider.videolink)
              "
              href="javascript:void(0)"
              tabindex="0"
            >
              <div class="icon">
                <img src="assets/images/video_icon.png" alt="icon" />
              </div>
            </a>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>
</section>
<section class="app-section">
  <div class="container">
    <div class="row v-row">
      <div class="col-lg-6">
        <img src="assets/images/mockup.png" class="img-1" />
        <img src="assets/images/mockup2.png" class="img-2" />
      </div>
      <div class="col-lg-6">
        <h3 class="sec_title">Available for your smart phone.</h3>
        <p>
          Selling made easy with our new mobile app.
          Manage your Orders, Shipping & Funds - all on the go.
        </p>
       
        <a href="https://apps.apple.com/us/app/fabpik-seller-world/id1550561400" target="_blank"><img src="assets/images/app-store-button.png" /></a>
        <a href="https://play.google.com/store/apps/details?id=com.fabpikproj" target="_blank"><img src="assets/images/google-play-button.png" /></a>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-6 offset-lg-3 text-center">
        <h3 class="sec_title">Keep in Touch</h3>
        <p>Here, there and everywhere, we are there for you!</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-4 col-xs-4 col-sm-4 mediaquote-link">
        <p>
          <img
          
            src="assets/images/quote3.PNG"
            alt="Icon"
          />
          Watch out the places to get Latest Updates and exclusive offers.<img
          
            src="assets/images/quote3.PNG"
            class="rotate-icon"
            alt="Icon"
          />
        </p>
      </div>
      <div class="col-lg-4 col-md-4 col-xs-4 col-sm-4 mediaquote-link">
        <p>
          <img
          
            src="assets/images/quote3.PNG"
            alt="Icon"
          />Never know, the next Big Gift could be yours!
          <img
          
            src="assets/images/quote3.PNG"
            class="rotate-icon"
            alt="Icon"
          />
        </p>
      </div>
      <div class="col-lg-4 col-md-4 col-xs-4 col-sm-4 mediaquote-link">
        <p>
          <img
          
            src="assets/images/quote3.PNG"
            alt="Icon"
          />Thodi si connection karlo, bacchon aur apno ko kush karlo!<img
          
            src="assets/images/quote3.PNG"
            class="rotate-icon"
            alt="Icon"
          />
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 offset-lg-3 text-center">
        <div class="row">
          <div class="col-lg-3 col-md-4 col-xs-4 col-sm-4 media-link">
            <a
              href="https://www.youtube.com/channel/UCDZDbmBT380YUB-KBSkds4Q?"
              target="_blank"
            >
              <div class="div-icon">
                <img src="assets/images/youtube-min.png" />
              </div>
              <h3>youtube</h3>
            </a>
          </div>
          <div class="col-lg-3 col-md-3 col-xs-4 col-sm-4 media-link">
            <a href="https://twitter.com/FabpikI" target="_blank">
              <div class="div-icon">
                <img src="assets/images/Twitter-min.png" />
              </div>
              <h3>twitter</h3>
            </a>
          </div>
          <div class="col-lg-3 col-md-3 col-xs-4 col-sm-4 media-link">
            <a
              href="https://www.instagram.com/fabpik.in/"
              target="_blank"
            >
              <div class="div-icon">
                <img src="assets/images/Instagram-min.png" />
              </div>
              <h3>Instagram</h3>
            </a>
          </div>
          <div class="col-lg-3 col-md-3 col-xs-4 col-sm-4 media-link">
            <a href="https://www.facebook.com/fabpik.in" target="_blank">
              <div class="div-icon">
                <img src="assets/images/facebook-min.png" />
              </div>
              <h3>facebook</h3>
            </a>
          </div>
          <div class="col-lg-3 col-md-3 col-xs-4 col-sm-4 media-link">
            <a href="https://in.pinterest.com/FabPikIndia/" target="_blank">
              <div class="div-icon">
                <img src="assets/images/pinterest-min.png" />
              </div>
              <h3>Pinterest</h3>
            </a>
          </div>
          <div class="col-lg-3 col-md-3 col-xs-4 col-sm-4 media-link">
            <a href="https://www.snapchat.com/add/fabpikindia" target="_blank">
              <div class="div-icon">
                <img src="assets/images/Snapchat-min.png" />
              </div>
              <h3>Snapchat</h3>
            </a>
          </div>
          <div class="col-lg-3 col-md-3 col-xs-4 col-sm-4 media-link">
            <a href="#" target="_blank">
              <div class="div-icon">
                <img src="assets/images/blog-min.png" />
              </div>
              <h3>Blog</h3>
            </a>
          </div>
          <div class="col-lg-3 col-md-3 col-xs-4 col-sm-4 media-link">
            <a href="#" target="_blank">
              <div class="div-icon">
                <img src="assets/images/podcast-min.png" />
              </div>
              <h3>Podcast</h3>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<ng-template #content2 let-modal>
  <div class="modal-body" class="video-popup-body">
    <div class="modal-body">
      <iframe
        width="100%"
        height="315"
        [src]="videoUrl"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</ng-template>
